var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Loading } from "@/shared/presentation/components/loading";
import { Center } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { useHistory } from "react-router";
export var PrivateRouteWrapper = function (_a) {
    var authClient = _a.authClient, props = __rest(_a, ["authClient"]);
    var _b = useState(), token = _b[0], setToken = _b[1];
    var _c = useContext(AuthContext), isValidated = _c.isValidated, rockId = _c.rockId, isEntityStandalone = _c.isEntityStandalone, clientWallets = _c.clientWallets;
    var history = useHistory();
    var firstAccessRoutes = [
        "/first-access",
        "/first-access/talent",
        "/first-access/ask-to-join",
        "/first-access/company",
    ];
    var employeeMyAccountRoutes = ["/my-account/company", "/my-account/users"];
    useEffect(function () {
        authClient
            .getToken()
            .then(setToken)
            .catch(function () { return authClient.login().then(setToken); });
    }, []);
    if (!token || isValidated === undefined) {
        return (React.createElement(Center, { h: "100vh", bg: "gray.100" },
            React.createElement(Loading, null)));
    }
    if (token) {
        if (isValidated === false) {
            window.location.href = process.env.LOGIN_URL + "/sign-up/email-confirmation";
        }
        var path = props === null || props === void 0 ? void 0 : props.path;
        var canNotAccessFirstAccessPages = rockId && !isEntityStandalone;
        if (firstAccessRoutes.includes(path) && canNotAccessFirstAccessPages) {
            history.push("/home");
        }
        var isEmployee = !!clientWallets.length;
        var pathName = window.location.pathname;
        if (employeeMyAccountRoutes.includes(pathName) && !isEmployee) {
            history.push("/my-account/profile");
        }
    }
    return React.createElement(Route, __assign({}, props));
};
